<script lang="ts">
import type { HTMLAttributes } from 'vue'

export type FieldErrorItem = string | { message?: string } | null | undefined

export interface FieldErrorProps {
  id?: string
  errors?: FieldErrorItem[]
  class?: HTMLAttributes['class']
}
</script>

<script setup lang="ts">
import { computed } from 'vue'
import { cn } from '#ui-kit/lib/utils'

const props = defineProps<FieldErrorProps>()

const slots = defineSlots<{
  default?: () => unknown
}>()

const messages = computed(() => {
  const all = (props.errors ?? []).map((error) => (typeof error === 'string' ? error : error?.message))
  return [...new Set(all.filter((message): message is string => !!message))]
})
</script>

<template>
  <div
    v-if="slots.default || messages.length"
    :id="props.id"
    role="alert"
    data-slot="field-error"
    :class="cn('text-sm text-error', props.class)"
  >
    <slot>
      <template v-if="messages.length === 1">
        {{ messages[0] }}
      </template>
      <ul v-else class="ml-4 list-disc">
        <li v-for="message in messages" :key="message">
          {{ message }}
        </li>
      </ul>
    </slot>
  </div>
</template>
